import { gql } from '@apollo/client'

const DIET_QUERY = gql`
  query diet($id: ID!) {
    diet(id: $id) {
      id
      name
      description
      updatedAt
      updatedBy {
        id
        name
      }
      node {
        id
        name
        isCurationEnabled
        level
        idPath
        namePath
        type
      }
      isAvailableForDishCategorization
      position
      maxPosition
      excludedAllergens {
        id
      }
      excludedIngredients {
        id
      }
      synonyms
      isExcludedFromSearch
      imageUrl
      onboardingImageUrl
      isPopular
    }
  }
`

export default DIET_QUERY
